import { useContext } from 'react';
import { AppContext } from '../../context/Contexte';

export default function Recommendation() {
  const { t } = useContext(AppContext);
  return (
    <div className="mb-4 text-center">
      <p> {t('text_alert')} </p>
    </div>
  );
}
